import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, AlertTriangle, BookOpen, Check, Shield, Zap, Star, Package, Clock, ArrowRight, Lock, Download, Layers, HeartPulse, ListChecks, AlertCircle } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function BonusSection() {
  return <section className="py-8 px-4 bg-[#FEFCF6] overflow-hidden" data-id="element-78">
      <div className="max-w-[800px] mx-auto" data-id="element-79">
        {/* BLOCK 1: TRANSITION INTRO */}
        <div className="text-center mb-16" data-id="element-80">
          <div className="inline-block bg-[#FFFBEB] border border-[#C17817]/30 px-4 py-1.5 rounded-full mb-6" data-id="element-81">
            <p className="text-[#C17817] font-bold text-xs uppercase tracking-widest" data-id="element-82">
              Pero espera. Antes de que cierres esta página...
            </p>
          </div>

          <p className="text-[#5C4A3A] text-lg mb-8 max-w-2xl mx-auto" data-id="element-83">
            Quiero asegurarme de que tengas todo lo que necesitas para que esto
            realmente funcione desde el primer día.
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-84">
            {['¿Y si no encuentro los ingredientes?', '¿Y si lo preparo mal y no me funciona?', '¿Y si me siento mal hoy y no sé qué hacer primero?'].map((excuse, i) => <div key={i} className="flex items-center gap-2 bg-white border border-[#E8DFD0] px-3 py-2 rounded-lg shadow-sm" data-id="element-85">
                <div className="bg-[#FEF2F2] p-1 rounded-full" data-id="element-86">
                  <AlertCircle className="w-3 h-3 text-[#B91C1C]" data-id="element-87" />
                </div>
                <span className="text-xs font-medium text-[#5C4A3A]" data-id="element-88">
                  {excuse}
                </span>
              </div>)}
          </div>

          <p className="text-[#2C1810] font-bold text-lg" data-id="element-89">
            Por eso decidí incluir 3 bonos diseñados para eliminar exactamente
            esas 3 excusas.
          </p>
        </div>

        {/* BLOCK 2: BONUS INTRO */}
        <div className="text-center mb-16" data-id="element-90">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2C1810] mb-4" data-id="element-91">
            No son "extras de relleno".
            <br data-id="element-92" />
            <span className="text-[#2D5A3D]" data-id="element-93">
              Son las piezas que convierten el manual en resultados reales.
            </span>
          </h2>
          <p className="text-[#5C4A3A] max-w-2xl mx-auto" data-id="element-94">
            Cada bono resuelve un problema específico que aparece entre
            "comprar" y "sentirte mejor".
            <br data-id="element-95" />
            <span className="font-bold text-[#C17817]" data-id="element-96">
              Y hoy los recibes completamente gratis.
            </span>
          </p>
        </div>

        {/* BLOCK 3: BONUS 1 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl border border-[#E8DFD0] shadow-lg overflow-hidden mb-12 relative" data-id="element-97">
          <div className="absolute top-0 right-0 bg-[#2D5A3D] text-white text-xs font-bold px-4 py-2 rounded-bl-xl z-10" data-id="element-98">
            VALOR: $47 — HOY GRATIS
          </div>

          <div className="flex flex-col md:flex-row" data-id="element-99">
            <div className="md:w-1/3 bg-[#F0F4EC] p-6 flex items-center justify-center relative overflow-hidden" data-id="element-100">
              <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-101"></div>
              <img src="https://cdn.magicpatterns.com/uploads/eidfksRvTvmbR7FMiFHWfR/bonus_1_col.png" alt="Botiquín Natural SOS" className="w-full h-auto rounded-lg shadow-xl transform rotate-[-2deg] hover:rotate-0 transition-transform duration-500 relative z-10" data-id="element-102" />
            </div>

            <div className="md:w-2/3 p-6 md:p-8" data-id="element-103">
              <div className="flex items-center gap-2 mb-2" data-id="element-104">
                <span className="text-[#C17817] font-bold text-xs uppercase tracking-wider" data-id="element-105">
                  BONO #1
                </span>
                <HeartPulse className="w-4 h-4 text-[#C17817]" data-id="element-106" />
              </div>

              <h3 className="text-2xl font-serif font-bold text-[#2C1810] mb-1" data-id="element-107">
                BOTIQUÍN NATURAL SOS
              </h3>
              <p className="text-[#5C4A3A] font-medium mb-6 italic" data-id="element-108">
                Gases • Gripa • Congestión • Garganta
              </p>

              <ul className="space-y-3 mb-6" data-id="element-109">
                {['SOS Gases e Hinchazón — infusión carminativa + calor local (15–20 min de alivio)', 'SOS Inicio de Gripa — bebida tibia + hidratación estratégica (actúa en las primeras 24h)', 'SOS Congestión Nasal — vapor + postura + ambiente (respira en 5–10 min)', 'SOS Dolor de Garganta — gárgaras + bebida suave + cuidados (alivio inmediato)', "Tabla '¿qué síntoma es cuál?' para no confundirte", 'Checklist de señales de alarma'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-[#2C1810]" data-id="element-110">
                    <Check className="w-4 h-4 text-[#2D5A3D] mt-0.5 shrink-0" data-id="element-111" />
                    <span data-id="element-112">{item}</span>
                  </li>)}
              </ul>

              <div className="bg-[#F0F4EC] p-4 rounded-lg border-l-4 border-[#2D5A3D]" data-id="element-113">
                <p className="text-[#2D5A3D] text-sm italic font-medium" data-id="element-114">
                  "La diferencia entre improvisar y actuar con un plan."
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* BLOCK 4: BONUS 2 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl border border-[#E8DFD0] shadow-lg overflow-hidden mb-12 relative" data-id="element-115">
          <div className="absolute top-0 right-0 bg-[#2D5A3D] text-white text-xs font-bold px-4 py-2 rounded-bl-xl z-10" data-id="element-116">
            VALOR: $47 — HOY GRATIS
          </div>

          <div className="flex flex-col md:flex-row" data-id="element-117">
            <div className="md:w-1/3 bg-[#FFFBEB] p-6 flex items-center justify-center relative overflow-hidden" data-id="element-118">
              <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-119"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3tbpQGWBkdLU7QErHtyWjJ/bonus_2_col.png" alt="Lista de Compras + Sustituciones" className="w-full h-auto rounded-lg shadow-xl transform rotate-[2deg] hover:rotate-0 transition-transform duration-500 relative z-10" data-id="element-120" />
            </div>

            <div className="md:w-2/3 p-6 md:p-8" data-id="element-121">
              <div className="flex items-center gap-2 mb-2" data-id="element-122">
                <span className="text-[#C17817] font-bold text-xs uppercase tracking-wider" data-id="element-123">
                  BONO #2
                </span>
                <ListChecks className="w-4 h-4 text-[#C17817]" data-id="element-124" />
              </div>

              <h3 className="text-2xl font-serif font-bold text-[#2C1810] mb-1" data-id="element-125">
                LISTA DE COMPRAS + SUSTITUCIONES
              </h3>
              <p className="text-[#5C4A3A] font-medium mb-6 italic" data-id="element-126">
                Tu alacena lista para aplicar La Medicina Natural
              </p>

              <ul className="space-y-3 mb-6" data-id="element-127">
                <li className="flex items-start gap-3 text-sm text-[#2C1810]" data-id="element-128">
                  <span className="w-2 h-2 rounded-full bg-[#C17817] mt-1.5 shrink-0" data-id="element-129"></span>
                  <span data-id="element-130">
                    <span className="font-bold" data-id="element-131">Capa BASE</span> — lo que más
                    vas a usar (lo primero que compras)
                  </span>
                </li>
                <li className="flex items-start gap-3 text-sm text-[#2C1810]" data-id="element-132">
                  <span className="w-2 h-2 rounded-full bg-[#2D5A3D] mt-1.5 shrink-0" data-id="element-133"></span>
                  <span data-id="element-134">
                    <span className="font-bold" data-id="element-135">Capa ACTIVADORES</span> — lo que
                    multiplica la absorción
                  </span>
                </li>
                <li className="flex items-start gap-3 text-sm text-[#2C1810]" data-id="element-136">
                  <span className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-1.5 shrink-0" data-id="element-137"></span>
                  <span data-id="element-138">
                    <span className="font-bold" data-id="element-139">Capa ESCUDOS</span> — lo que
                    protege mientras sanas
                  </span>
                </li>
                {['Tabla de sustituciones 1:1 — Si no hay hinojo, usa anís. Nunca te quedes parado.', 'Versión económica vs premium — funciona con presupuesto real', 'Dónde comprar: súper, mercado, tienda naturista, online', 'Tracker de 7 días — energía, claridad, sueño y digestión del 1 al 5'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-[#2C1810]" data-id="element-140">
                    <Check className="w-4 h-4 text-[#2D5A3D] mt-0.5 shrink-0" data-id="element-141" />
                    <span data-id="element-142">{item}</span>
                  </li>)}
              </ul>

              <div className="bg-[#FFFBEB] p-4 rounded-lg border-l-4 border-[#C17817]" data-id="element-143">
                <p className="text-[#C17817] text-sm italic font-medium" data-id="element-144">
                  "Compra inteligente en 1 visita. Sin adivinar. Sin
                  frustrarte."
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* BLOCK 5: BONUS 3 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl border border-[#E8DFD0] shadow-lg overflow-hidden mb-16 relative" data-id="element-145">
          <div className="absolute top-0 right-0 bg-[#2D5A3D] text-white text-xs font-bold px-4 py-2 rounded-bl-xl z-10" data-id="element-146">
            VALOR: $47 — HOY GRATIS
          </div>

          <div className="flex flex-col md:flex-row" data-id="element-147">
            <div className="md:w-1/3 bg-[#F0F9FF] p-6 flex items-center justify-center relative overflow-hidden" data-id="element-148">
              <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-149"></div>
              <img src="https://cdn.magicpatterns.com/uploads/jzCF96rkSa3stacgV5d2Lz/bonus_3_col.png" alt="Guía Anti-Error" className="w-full h-auto rounded-lg shadow-xl transform rotate-[-1deg] hover:rotate-0 transition-transform duration-500 relative z-10" data-id="element-150" />
            </div>

            <div className="md:w-2/3 p-6 md:p-8" data-id="element-151">
              <div className="flex items-center gap-2 mb-2" data-id="element-152">
                <span className="text-[#C17817] font-bold text-xs uppercase tracking-wider" data-id="element-153">
                  BONO #3
                </span>
                <Shield className="w-4 h-4 text-[#C17817]" data-id="element-154" />
              </div>

              <h3 className="text-2xl font-serif font-bold text-[#2C1810] mb-1" data-id="element-155">
                GUÍA ANTI-ERROR: DOSIS Y SEGURIDAD
              </h3>
              <p className="text-[#5C4A3A] font-medium mb-6 italic" data-id="element-156">
                Aplica La Medicina Natural con confianza (sin pánico)
              </p>

              <ul className="space-y-3 mb-6" data-id="element-157">
                {['Tabla de medidas reales de cocina — 1 cdta = 5ml. Sin adivinar.', 'Infusión vs Decocción vs Maceración — cuándo usar cada una', 'Tiempos exactos — 7–12 min tapada para infusión. El tiempo cambia todo.', 'Los 7 errores que arruinan resultados — evítalos y tus resultados suben solos', 'Checklist de seguridad en 30 segundos — alergias, medicamentos', 'Plantilla para hablar con tu médico — sin confrontación, sin drama'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-[#2C1810]" data-id="element-158">
                    <Check className="w-4 h-4 text-[#2D5A3D] mt-0.5 shrink-0" data-id="element-159" />
                    <span data-id="element-160">{item}</span>
                  </li>)}
              </ul>

              <div className="bg-[#F0F9FF] p-4 rounded-lg border-l-4 border-[#0284C7]" data-id="element-161">
                <p className="text-[#0284C7] text-sm italic font-medium" data-id="element-162">
                  "La diferencia entre 'no me funcionó' y 'wow, sí se siente'
                  casi siempre es cómo lo preparaste."
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* BLOCK 6: VALUE STACK TABLE */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#2D5A3D] rounded-2xl p-6 md:p-8 text-white mb-16 shadow-2xl relative overflow-hidden" data-id="element-163">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-164"></div>

          <h3 className="text-2xl font-serif font-bold text-center mb-8" data-id="element-165">
            TODO LO QUE RECIBES HOY
          </h3>

          <div className="space-y-4 mb-8" data-id="element-166">
            <div className="flex justify-between items-center border-b border-white/10 pb-3" data-id="element-167">
              <div className="flex items-center gap-3" data-id="element-168">
                <BookOpen className="w-5 h-5 text-[#C17817]" data-id="element-169" />
                <span className="font-medium" data-id="element-170">
                  La Medicina Natural (manual principal)
                </span>
              </div>
              <span className="font-bold" data-id="element-171">$149</span>
            </div>

            <div className="flex justify-between items-center border-b border-white/10 pb-3" data-id="element-172">
              <div className="flex items-center gap-3" data-id="element-173">
                <Package className="w-5 h-5 text-[#C17817]" data-id="element-174" />
                <span className="font-medium" data-id="element-175">
                  Bono #1 — Botiquín Natural SOS
                </span>
              </div>
              <span className="font-bold" data-id="element-176">$47</span>
            </div>

            <div className="flex justify-between items-center border-b border-white/10 pb-3" data-id="element-177">
              <div className="flex items-center gap-3" data-id="element-178">
                <Package className="w-5 h-5 text-[#C17817]" data-id="element-179" />
                <span className="font-medium" data-id="element-180">
                  Bono #2 — Lista de Compras + Sustituciones
                </span>
              </div>
              <span className="font-bold" data-id="element-181">$47</span>
            </div>

            <div className="flex justify-between items-center border-b border-white/10 pb-3" data-id="element-182">
              <div className="flex items-center gap-3" data-id="element-183">
                <Package className="w-5 h-5 text-[#C17817]" data-id="element-184" />
                <span className="font-medium" data-id="element-185">Bono #3 — Guía Anti-Error</span>
              </div>
              <span className="font-bold" data-id="element-186">$47</span>
            </div>

            <div className="flex justify-between items-center border-b border-white/10 pb-3 text-[#A7F3D0]" data-id="element-187">
              <div className="flex items-center gap-3" data-id="element-188">
                <Shield className="w-5 h-5" data-id="element-189" />
                <span className="font-medium" data-id="element-190">Garantía 7 días sin riesgo</span>
              </div>
              <span className="font-bold uppercase" data-id="element-191">Incluida</span>
            </div>

            <div className="flex justify-between items-center text-[#A7F3D0]" data-id="element-192">
              <div className="flex items-center gap-3" data-id="element-193">
                <Zap className="w-5 h-5" data-id="element-194" />
                <span className="font-medium" data-id="element-195">Acceso digital inmediato</span>
              </div>
              <span className="font-bold uppercase" data-id="element-196">Incluido</span>
            </div>
          </div>

          <div className="bg-white/10 rounded-xl p-6 text-center backdrop-blur-sm" data-id="element-197">
            <p className="text-white/70 text-sm font-medium mb-1 uppercase tracking-widest" data-id="element-198">
              Valor Total Real
            </p>
            <p className="text-2xl text-white/50 line-through font-bold mb-2" data-id="element-199">
              $290 USD
            </p>
            <p className="text-[#FCD34D] text-5xl font-bold tracking-tight mb-6" data-id="element-200">
              $6.97
            </p>
            <a href="https://pay.hotmart.com/D104591124J?off=pf8xmxms" onClick={() => trackAddToCart()} className="block w-full bg-gradient-to-r from-[#B91C1C] to-[#991B1B] text-white font-bold py-4 px-6 rounded-xl text-base uppercase tracking-wide shadow-[0_4px_14px_0_rgba(185,28,28,0.4)] hover:-translate-y-1 transition-all duration-300" data-id="element-201">
              SÍ — QUIERO EL MANUAL + LOS 3 BONOS GRATIS
            </a>
            <div className="flex items-center justify-center gap-1.5 mt-3" data-id="element-202">
              <Lock className="w-3 h-3 text-white/60" data-id="element-203" />
              <span className="text-white/60 text-xs" data-id="element-204">
                Solo $6.97 · Acceso inmediato · Garantía 7 días
              </span>
            </div>
          </div>
        </motion.div>

        {/* BLOCK 7: EMOTIONAL CLOSE + CTA */}
        <div className="text-center max-w-2xl mx-auto" data-id="element-205">
          <p className="text-[#5C4A3A] font-medium italic mb-6" data-id="element-206">
            Por menos de lo que cuesta una sola infusión en una cafetería...
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left mb-8" data-id="element-207">
            {['El manual completo', 'El botiquín de emergencia', 'La lista para comprar sin frustrarte', 'La guía para preparar sin equivocarte'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-208">
                <Check className="w-4 h-4 text-[#2D5A3D] shrink-0" data-id="element-209" />
                <span className="text-[#2C1810] font-bold text-sm" data-id="element-210">{item}</span>
              </div>)}
          </div>

          <h3 className="text-xl font-serif font-bold text-[#2C1810] mb-6" data-id="element-211">
            ¿Cuántos días más vas a esperar para empezar a sentirte mejor?
          </h3>

          <div className="flex flex-col items-center gap-2 text-xs text-[#5C4A3A]" data-id="element-212">
            <div className="flex items-center gap-1.5" data-id="element-213">
              <Lock className="w-3 h-3 text-[#2D5A3D]" data-id="element-214" />
              <span className="font-bold" data-id="element-215">
                Tu compra está protegida al 100% por nuestra Garantía Sin Riesgo
                de 7 días.
              </span>
            </div>
            <p className="opacity-80 max-w-md" data-id="element-216">
              Si en 7 días no sientes ninguna diferencia, te devolvemos cada
              centavo. Sin preguntas. Sin trámites. Sin letra chica.
            </p>
          </div>
        </div>
      </div>
    </section>;
}